
import moment from 'moment';
import axios from 'axios';
import Amplify from 'aws-amplify'
import awsconfig from '../aws-exports'

export default {
    created() {
    },
    data() {
        return {
            EMSTATE: {
              'full': 'full_time_employee',
              'part': 'part_time_job',
              'temporary': 'temporary_staff',
              'contract': 'contract_employee',
            },
            AUTHMODE: 'user',
            serverPass: "test",
            currentAuthMode: 'user',
            LANG_DICT: { en: "en", ja: "ja", ban: "ban", bur: "bur", ch: "ch", hin: "hi", ind: "id", kh: "ku",lao: "lao", mon: "mon", ne: "ne", taga: "tage", thai: "thai", vi: "vi"},
            INDUSTRY_DICTIONARY: {
              1: "介護業",
              2: "ビルクリーニング業",
              3: "素形材産業",
              4: "産業機械製造業",
              5: "電気・電子情報関連産業",
              6: "建設業",
              7: "造船・舶用業",
              8: "自動車整備業",
              9: "航空業",
              10: "宿泊業",
              11: "農業",
              12: "漁業",
              13: "飲食料品製造",
              14: "外食業",
              15: "素形材・産業機械・電気電子情報関連製造業",
            },
            /* 試験の実施概要のラベル */
            LABELS: {
              "language": "",
              "method": "",
              "way": "",
              "section": "",
              "notify": "",
              "border": ""
            },
            LANGUAGE_LIST: {
               "vietnamese": 'vi',
               "english": 'en',
               "khmer": 'kh',
               "indonesian": 'id',
               "tagalog": 'tl',
               "hindu": 'hi',
               "lao": 'lo',
               "mongolian": 'mn',
               "bengali": 'bn',
               "japanese": 'ja',
               "nepali": "ne",
               "thai": "th",
               "myanmar": 'bur',
               "sinhalese": 'lk'
            },
            R_LANGUAGE_LIST: {
              'vi': "vietnamese",
              'ch': "chinese",
              'en': "english",
              'kh': "khmer",
              'id': "indonesian",
              'tl': "tagalog",
              'bur': "myanmar",
              'hi': "hindu",
              'lo': "lao",
              'mn': "mongolian",
              'bn': "bengali",
              'ja': "japanese",
              "th": "thai",
              "lk": "sinhalese"
            },
            GENDER_LIST: {
              "man": "男性",
              "female": "女性"
            },
            LANGUAGE_ARR: [
              "vietnamese",
              "english",
              "khmer",
              "indonesian",
              "tagalog",
              "myanmar",
              "hindu",
              "lao",
              "mongolian",
              "bengali",
              "japanese",
              "nepali",
              "thai",
              "sinhalese"
            ],
            LANGUAGE_FLAG_SELECT: [

              {cardImage: "@/assets/flag/vietnamese.png", title: "vietnamese"},
              "english",
              "khmer",
              "indonesian",
              "tagalog",
              "myanmar",
              "hindu",
              "lao",
              "mongolian",
              "bengali",
              "japanese",
              "nepali",
              "thai",
              "sinhalese"
            ],
            TRANS_LANGUAGE_LIST: {
              'vi': "vi",
              'ch': "zh",
              'en': "en",
              'kh': "km",
              'id': "id",
              'tl': "tl",
              'bur': "my",
              'hi': "hi",
              'lo': "lo",
              'mn': "mn",
              'bn': "bn",
              'ja': "ja",
              "th": "th",
              "lk": "si"
            },
            PREFECTURES: [
              { value: '', text: '希望都道府県' },
              { value: '北海道', text: '北海道' },
              { value: '青森県', text: '青森県' },
              { value: '岩手県', text: '岩手県' },
              { value: '宮城県', text: '宮城県' },
              { value: '秋田県', text: '秋田県' },
              { value: '山形県', text: '山形県' },
              { value: '福島県', text: '福島県' },
              { value: '茨城県', text: '茨城県' },
              { value: '栃木県', text: '栃木県' },
              { value: '群馬県', text: '群馬県' },
              { value: '埼玉県', text: '埼玉県' },
              { value: '千葉県', text: '千葉県' },
              { value: '東京都', text: '東京都' },
              { value: '神奈川県', text: '神奈川県' },
              { value: '新潟県', text: '新潟県' },
              { value: '富山県', text: '富山県' },
              { value: '石川県', text: '石川県' },
              { value: '福井県', text: '福井県' },
              { value: '山梨県', text: '山梨県' },
              { value: '長野県', text: '長野県' },
              { value: '岐阜県', text: '岐阜県' },
              { value: '静岡県', text: '静岡県' },
              { value: '愛知県', text: '愛知県' },
              { value: '三重県', text: '三重県' },
              { value: '滋賀県', text: '滋賀県' },
              { value: '京都府', text: '京都府' },
              { value: '大阪府', text: '大阪府' },
              { value: '兵庫県', text: '兵庫県' },
              { value: '奈良県', text: '奈良県' },
              { value: '和歌山県', text: '和歌山県' },
              { value: '鳥取県', text: '鳥取県' },
              { value: '島根県', text: '島根県' },
              { value: '岡山県', text: '岡山県' },
              { value: '広島県', text: '広島県' },
              { value: '山口県', text: '山口県' },
              { value: '徳島県', text: '徳島県' },
              { value: '香川県', text: '香川県' },
              { value: '愛媛県', text: '愛媛県' },
              { value: '高知県', text: '高知県' },
              { value: '福岡県', text: '福岡県' },
              { value: '佐賀県', text: '佐賀県' },
              { value: '長崎県', text: '長崎県' },
              { value: '熊本県', text: '熊本県' },
              { value: '大分県', text: '大分県' },
              { value: '宮崎県', text: '宮崎県' },
              { value: '鹿児島県', text: '鹿児島県' },
              { value: '沖縄県', text: '沖縄県' },
            ],
            INCOMES: [
              { value: '', text: '希望月収' },
              { value: '10-15', text: '10~15万' },
              { value: '15-20', text: '15~20万' },
              { value: '20-25', text: '20~25万' },
              { value: '25-30', text: '25~30万' },
              { value: '30-35', text: '30~35万' },
              { value: '35-40', text: '35~40万' },
            ],
            DORMITORY: [
              { value: 'true', text: '有り' },
              { value: 'false', text: '無し' },
            ],
            INDUSTRY_OPTIONS: [
              { value: '', text: '業種' },
              { value: '1', text: '介護業' },
              { value: '2', text: 'ビルクリーニング業' },
              { value: '3', text: '素形材産業' },
              { value: '4', text: '産業機械製造業' },
              { value: '5', text: '電気・電子情報関連産業' },
              { value: '6', text: '建設業' },
              { value: '7', text: '造船・舶用業' },
              { value: '8', text: '自動車整備業' },
              { value: '9', text: '航空業' },
              { value: '10', text: '宿泊業' },
              { value: '11', text: '農業' },
              { value: '12', text: '漁業' },
              { value: '13', text: '飲食料品製造' },
              { value: '14', text: '外食業' },
              { value: '15', text: '素形材・産業機械・電気電子情報関連製造業' },
            ],
            INDUSTRY_OCCUPATION: {
              "1": [
                "介護"
              ],
              "2": [
                "ビルクリーニング"
              ],
              "3": [
                "鋳造", "鍛造", "ダイカスト", "機械加工", "金属プレス加工", "工場板金", "めっき", "アルミニウム", "仕上げ", "機械検査", "機械保全", "塗装", "溶接"
              ],
              "4": [
                "鋳造", "鍛造", "ダイカスト", "機械加工", "金属プレス加工", "工場板金", "めっき", "鉄工", "仕上げ", "機械検査", "機械保全", "塗装", "溶接", "電子機器組立て", "電気機器組立て", "プリント配線板製造", "プラスチック成形", "工業包装"
              ],
              "5": [
                "機械加工", "金属プレス加工", "工場板金", "めっき", "仕上げ", "機械保全", "電子機器組立て", "電気機器組立て", "プリント配線板製造", "プラスチック成形", "工業包装", "塗装", "溶接"
              ],
              "6": [
                "建築板金", "建築大工", "型枠施工", "鉄筋施工", "とび", "屋根ふき", "左官", "配管", "保温保冷", "内装仕上げ", "コンクリート圧送", "表装", "建設機械施工"
              ],
              "7": [
                "機械加工", "鉄工", "仕上げ", "電気機器組立て", "プリント配線板製造", "塗装", "溶接"
              ],
              "8": [
                "自動車整備"
              ],
              "9": [
                "空港グランドハンドリング"
              ],
              "10": [
                "宿泊"
              ],
              "11": [
                "耕種農業", "畜産農業"
              ],
              "12": [
                "漁船漁業"
              ],
              "13": [
                "飲食料品製造業全般"
              ],
              "14": [
                "医療・福祉施設給食製造"
              ]
            },
            PUBLIC_OPTIONS: [
              { value: 'public', text: '募集中' },
              { value: 'private', text: '非公開' },
            ],
            WORKTIMEOPTIONS: [
              { value: '1', text: '1:00' },
              { value: '2', text: '2:00' },
              { value: '3', text: '3:00' },
              { value: '4', text: '4:00' },
              { value: '5', text: '5:00' },
              { value: '6', text: '6:00' },
              { value: '7', text: '7:00' },
              { value: '8', text: '8:00' },
              { value: '9', text: '9:00' },
              { value: '10', text: '10:00' },
              { value: '11', text: '11:00' },
              { value: '12', text: '12:00' },
              { value: '13', text: '13:00' },
              { value: '14', text: '14:00' },
              { value: '15', text: '15:00' },
              { value: '16', text: '16:00' },
              { value: '17', text: '17:00' },
              { value: '18', text: '18:00' },
              { value: '19', text: '19:00' },
              { value: '20', text: '20:00' },
              { value: '21', text: '21:00' },
              { value: '22', text: '22:00' },
              { value: '23', text: '23:00' },
              { value: '24', text: '24:00' },
            ],
            WORKTIME: {
              '1': '1:00',
              '2': '2:00',
              '3': '3:00',
              '4': '4:00',
              '5': '5:00',
              '6': '6:00',
              '7': '7:00',
              '8': '8:00',
              '9': '9:00',
              '10':'10:00',
              '11':'11:00',
              '12':'12:00',
              '13':'13:00',
              '14':'14:00',
              '15':'15:00',
              '16':'16:00',
              '17':'17:00',
              '18':'18:00',
              '19':'19:00',
              '20':'20:00',
              '21':'21:00',
              '22':'22:00',
              '23':'23:00',
              '24':'24:00',
            },
            MARRIEDLIST: {
              'single':'独身者',
              'married':'既婚者',
              'no':'不問',
            },
            JAPAN_LIVE: [
                {value: "0", text: "在歴無し"},
                {value: "1", text: "1年"},
                {value: "2", text: "2年"},
                {value: "3", text: "3年"},
                {value: "4", text: "4年"},
                {value: "5", text: "5年"},
                {value: "6", text: "6年"},
            ],
            AGE_LIST: [
              1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100
            ],
            JAPANESELIST: {
              'N1': 'N1' ,
              'N2': 'N2',
              'N3': 'N3' ,
            },
            HOPELIST: {
              'china': '中国',
              'usa': 'アメリカ',
              'indi': 'インド' ,
            },
            EDUCARIONALLIST: {
              'junior': '中卒以上' ,
              'high': '高卒以上',
              'uni': '大卒以上' ,
              'no': '不問' ,
            },
            OVERSEASLIST: {
              '1': '可能',
              '2': '不可',
            },
            BREAKTIMELIST: {
              '1': '11:00 ~ 12:00',
              '2': '12:00 ~ 13:00',
              '3': '13:00 ~ 14:00',
              '4': '14:00 ~ 15:00',
            },
            TIMEMANAGEMENTLIST: {
              '1': 'タイムカード' ,
              '2': '本人手書き',
            },
            MEALLIST: {
              '1': '自炊' ,
              '2': '弁当提供',
            },
            WORKCLOTHLIST: {
              '1': '有り(貸与)' ,
              '2': '有り(指定服自己負担)',
              '3': 'なし' ,
              '4': 'その他' ,
            },
            PLACELIST: {
              '1': '会社敷地内' ,
              '2': '会社近隣借上(マンション)' ,
              '3': '会社近隣借上(アパート)' ,
            },
            MOVINGLIST: {
              '1': 'あり',
              '2': 'なし' ,
            },
            WAGELIST: {
              '1': 'システム利用',
              '2': 'その他',
            },

            CollectionFeeDict: {
              '1': '本人負担',
              '2': '会社負担'
            },


        }
    },
    methods: {
      /* 日付データを引数とし、フォーマットを合わせる */
      format_day(d) {
        return moment(d).format("YYYY.M.DD")
      },
      /* ニュースの日付フォーマットを合わせる */
      format_day_news(news){
        if(news != undefined) {
          if (news['created_at'] != undefined){
            return moment(news['created_at']).format("YYYY.M.DD")
          }
        }
      },
      format_date_full(d){
        if(d == undefined){
          return '未設定'
        }
         moment.locale("ja" ,{
            weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
            weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
          });
        return moment(d).format('YYYY/MM/DD (ddd)')
      },
      translate(t, lang) {
        var idToken = localStorage.idToken
        axios
          .post(process.env.VUE_APP_API + "/trial_examination/translate", {text: t, lang: lang}, {headers: {'Authorization': 'Bearer ' + idToken}})
          .then((res) => {
             return res.data.text
          })
      },
      invalid_d(d) {
        console.log(d)
        if(moment(d, 'YYYY-MM-DD', true).isValid() == false){
          if(moment(d, 'YYYY/MM/DD', true).isValid() == false){
            if(moment(d, 'YYYY/M/D', true).isValid() == false){
              if(moment(d, 'YYYY年MM月DD日', true).isValid() == false){
                return false
              }
            }
          }
        }
        return true
    },
      format_y(d) {
        return moment(d).format("YYYY")
      },
      format_m(d) {
        var m = moment(d, 'YYYY-MM-DD', true)
        if(m.isValid() == false) {
          m = moment(d, "YYYY年MM月DD日", true)
          if(m.isValid() == false) {
            return ""
          } else {
            return m.format("M")
          }
        } else {
          return m.format("M")
        }
      },
      format_d(d) {
        var m = moment(d, 'YYYY-MM-DD', true)
        if(m.isValid() == false) {
          m = moment(d, "YYYY年MM月DD日", true)
          if(m.isValid() == false) {
            return ""
          } else {
            return m.format("DD")
          }
        } else {
          return m.format("DD")
        }
      },
      format_tz() {
        return moment.tz(moment.tz.guess()).zoneAbbr()
      },
      format_daytime(d) {
        var m = moment(d).format("YYYY.M.DD HH:mm ")
        if(m == "") {
          return m
        } else {
          return ""
        }
      },
      format_daytime2(d) {
        var m = moment(d).format("YYYY/MM/DD HH:mm:ss ")
        if(m != "") {
          return m
        } else {
          return ""
        }
      },
      formate_date(d) {
        return moment(d).format("M月DD日")
      },
      format_time(d){
        if(d == undefined) {
          return "--"
        } else {
          return moment(d).format("HH:mm")
        }
      },
      switchAuth(changeType){
        if(changeType != this.AUTHMODE){
          if(changeType == 'user'){
            awsconfig.aws_user_pools_id = process.env.VUE_APP_AWS_POOLS_ID
            awsconfig.aws_user_pools_web_client_id = process.env.VUE_APP_AWS_WEB_CLIENT_ID
            awsconfig.oauth.domain = process.env.VUE_APP_AWS_DOMAIN
            awsconfig.oauth.redirectSignIn = process.env.VUE_APP_AWS_REDIRECT_URL
            awsconfig.oauth.redirectSignOut = process.env.VUE_APP_AWS_REDIRECT_URL
            awsconfig.oauth.responseType = process.env.VUE_APP_AWS_RESPONSETYPE
            this.currentAuthMode = changeType 
            Amplify.configure(awsconfig)
          } else if(changeType == 'organization'){
            awsconfig.aws_user_pools_id = process.env.VUE_APP_AWS_POOLS_ID_BUSINESS
            awsconfig.aws_user_pools_web_client_id = process.env.VUE_APP_AWS_WEB_CLIENT_ID_BUSINESS
            awsconfig.oauth.domain = process.env.VUE_APP_AWS_DOMAIN_BUSINESS
            awsconfig.oauth.redirectSignIn = process.env.VUE_APP_AWS_REDIRECT_URL
            awsconfig.oauth.redirectSignOut = process.env.VUE_APP_AWS_REDIRECT_URL
            awsconfig.oauth.responseType = process.env.VUE_APP_AWS_RESPONSETYPE
            this.currentAuthMode = changeType 
            Amplify.configure(awsconfig)
          }
        }
      }

    },
    computed: {
    }
}
